import { type CSSProperties } from 'react'
import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { APPBAR_HEIGHT, APPBAR_LG_HEIGHT } from '@Styles/constants/layout'

export const page = (theme: Theme, sizePage: 'small' | 'large'): SerializedStyles =>
  css({
    backgroundColor: theme.customPalette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    maxHeight: '-webkit-fill-available',
    width: '100vw',
    [theme.breakpoints.up('md')]: {
      maxWidth: rem(830),
      width: sizePage === 'small' ? rem(560) : '100vw',
    },
  })

export const contentWrapper = (theme: Theme): SerializedStyles =>
  css({
    '& > form': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100% - ${APPBAR_HEIGHT})`,
    outline: 0,
    [theme.breakpoints.up('lg')]: {
      height: `calc(100% - ${APPBAR_LG_HEIGHT})`,
    },
  })

export const scrollableContent = css({
  flex: 1,
  overflow: 'auto',
})

export const content = (theme: Theme): SerializedStyles =>
  css({
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(5),
    },
  })

export const paper: CSSProperties = {
  overflowY: 'unset',
}
